import { render, staticRenderFns } from "./StepProducts.vue?vue&type=template&id=2838e868&scoped=true&"
import script from "./StepProducts.vue?vue&type=script&lang=js&"
export * from "./StepProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838e868",
  null
  
)

export default component.exports